import Vue from 'vue';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';

const state = {
  isConversationAssigned: false
};

export const getters = {
  getIsConversationAssigned: $state => $state.isConversationAssigned,
};

export const actions = {};

const mutations = {
  toggleIsConversationAssigned($state) {
    $state.isConversationAssigned = !$state.isConversationAssigned;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
